module.exports = __webpack_public_path__ + "img/mantenimiento.09013f31.png";